
import Vue from "vue";
import AppCompanyEditDefault from "@/components/company/CompanyEditDefault.vue";
import AppCompanyInfoWrapper from "./CompanyInfoWrapper.vue";
import { Company } from "@/models/company";

export default Vue.extend({
	props: {
		company: {
			type: Object as ()=>Company,
			required: true
		}
	},
	components: {
		AppCompanyEditDefault,
		AppCompanyInfoWrapper
	}
});
